import { createLayouts } from '@layouts'
import { layoutConfig } from '@themeConfig'

// Styles
// 第三方 CSS 一律用 JS 匯入，不要在 SCSS 裡 @use。Sass 內聯後分層外掛只看得到來源是
// resources/，會把它包進 app 層、壓過其他第三方套件與 Vuetify 元件。
import 'overlayscrollbars/overlayscrollbars.css'
import '@layouts/styles/index.scss'

export default function (app) {
  // ℹ️ We generate layout config from our themeConfig so you don't have to write config twice
  app.use(createLayouts(layoutConfig))
}
